export default {
  reg: {
    letter: 'Jedynie litery angielskie i spacje są dozwolone'
  }
}
